import _ from 'lodash';
import Cognito from '../../../../global/js/cognito';
import {utils} from '../../../../global/js/utils';
import LoadingSpinner from '../../../../global/js/loading-spinner';
import {ForgotPasswordModal} from '../../forgotPasswordModal/js/forgotPasswordModal';
import {VerifyAccountModal} from '../../verifyAccountModal/js/verifyAccountModal';
import {AuthenticationUtils} from './authenticationUtils';

export class LoginModal {
	constructor() {
		// Load template
		this.template = $('#SignInModal').html();
		// Initialize User Pool
		this.userPool = Cognito.getUserPool({
			UserPoolId: window.cognitoUserPoolId,
			ClientId: window.cognitoAppClientId,
		});

		this.cognitoUser = null;
		this.$modal = null;
		this.$serverError = null;
		this.$btnLogin = null;

		this.forgotModal = new ForgotPasswordModal();
		this.verifyModal = new VerifyAccountModal({
			onVerified: ()=> {
				// Auto-login if verifying account successfully
				this.authenticatedHandler();
			},
		});
		this.authUtils = new AuthenticationUtils();
	}

	init() {
		this.open();
		this.addEventHandler();
	}

	open() {
		this.$modal = $('[data-role="login-modal"]');
		if (this.$modal.length) {
			this.$modal.removeClass('hidden');
		} else {
			$('body').append(this.template);
			this.$modal = $('[data-role="login-modal"]');
			setTimeout(()=> {
				this.$modal.removeClass('hidden');
			}, 300);
		}
		this.$serverError = this.$modal.find('.server-error');
		this.$btnLogin = this.$modal.find('.btn-login');
	}

	close() {
		if (this.$modal && this.$modal.length) {
			this.$modal.addClass('hidden');

			// Reset style
			this.$modal.find('.form-group').removeClass('error');
			this.$modal.find('input').val('');
			this.$modal.find('.error').html('');
			this.$serverError.html('');
		}
	}

	addEventHandler() {
		if (!this.$modal || !this.$modal.length) return;
		this.$modal
			.off('click.close')
			.on('click.close', '.popup-close', (e)=> {
				e.preventDefault();
				this.close();
			});

		this.$modal
			.off('click.reset')
			.on('click.reset', '.btn-reset', (e)=> {
				e.preventDefault();
				this.forgotModal.init();
			});

		this.$modal
			.off('click.login')
			.on('click.login', '.btn-login', (e)=> {
				const validateData = this.validateForm();
				if (validateData.isValid) {
					this.login(validateData.formData.username, validateData.formData.password);
				}
				return false;
			});
	}

	validateForm() {
		const $username = this.$modal.find('#username');
		const $password = this.$modal.find('#password');
		const $userError = $username.siblings('.error');
		const $userFormGrp = $userError.closest('.form-group');
		const $passwordError = $password.siblings('.error');
		const $passwordFormGrp = $password.closest('.form-group');
		const username = $username.val().trim();
		const password = $password.val().trim();
		let invalidUserName = false;
		let invalidPassword = false;
		if (!username) {
			$userError.html('<span>Email is required.</span>');
			$userFormGrp.addClass('error');
			invalidUserName = true;
		} else if (!utils.isEmail(username)) {
			$userError.html('<span>Email is invalid.</span>');
			$userFormGrp.addClass('error');
			invalidUserName = true;
		} else {
			$userError.html('');
			$userFormGrp.removeClass('error');
			invalidUserName = false;
		}

		if (!password) {
			$passwordError.html('<span>Password is required.</span>');
			$passwordFormGrp.addClass('error');
			invalidPassword = true;
		} else {
			$passwordError.html('');
			$passwordFormGrp.removeClass('error');
			invalidPassword = false;
		}
		return {
			isValid: !invalidUserName && !invalidPassword,
			formData: {
				username: username,
				password: password,
			},
		};
	}

	login(username, password) {
		const authenticationDetails = Cognito.createAuthData(username, password);
		const userData = Cognito.createUserData(username, this.userPool);
		const cognitoUser = Cognito.getCognitoUser(userData);
		this.cognitoUser = cognitoUser;

		this.$btnLogin.prop('disabled', true);
		return this.authUtils.login(
			authenticationDetails,
			{
				cognitoUser: this.cognitoUser,
				userPool: this.userPool,
				onAuthenticatedSuccess: (result)=> {
					this.authenticatedHandler(result);
				},
				onAskedToVerify: () => {
					this.verifyModal.init();
					this.$btnLogin.prop('disabled', false);
					this.close();
				},
				onError: (err)=> {
					this.errorHandler(err.message);
				},
			});
	}

	signinHandler(token) {
		LoadingSpinner.show();
		this.authUtils.signin(token)
			.then((response)=> {
				if (response && response.data && response.data.ErrorCode) {
					this.errorHandler(response.data.ErrorMessage, 'overflow-scroll');
				} else {
					window.location.reload();
				}
			}, (err)=> {
				this.errorHandler(err.response.data.Message || err.response.data);
			}).finally(()=> {
				LoadingSpinner.hide();
			});
	}

	errorHandler(errorMsg, cssClass) {
		this.$serverError.html(`<span${cssClass? ` class=${cssClass}`:''}>${errorMsg}</span>`);
		this.$btnLogin.prop('disabled', false);
	}

	authenticatedHandler(result) {
		if (result) {
			const token = result.getIdToken().getJwtToken();
			this.signinHandler(token);
		} else {
			Cognito.getToken(this.userPool)
				.then((token)=> {
					this.signinHandler(token);
				}, (err)=> {
					this.errorHandler(err.message);
				});
		}
	}
}
